module.exports = __webpack_public_path__ + "static/media/gq.0c1057b3.svg";